// extracted by mini-css-extract-plugin
export var text = "_4i-0";